import GraphView from "@/components/wastePerGuestPerServiceTime/graphView.vue";
import TableView from "@/components/wastePerGuestPerServiceTime/tableView.vue";

export default {
	props: {
		current: {
			type: Object,
			required: true,
		},
		compare: {
			type: Object,
			required: true,
		},
	},

	components: {
		GraphView,
		TableView,
	},

	data() {
		return { isGraphMode: true };
	},
};
